export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(qualificationType => qualificationType.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, qualificationTypes) {
      state.all = qualificationTypes
      state.loading = false
    },
    set(state, qualificationType) {
      state.all = state.all.filter(o => o.id != qualificationType.id)
      state.all.push(qualificationType)
    },
    remove(state, id) {
      state.all = state.all.filter(o => o.id != id)
    }
  },
  actions: {
    fetchAll({ commit }) {
      this.$authorize('list', 'QualificationType')

      commit('startLoading')
      return Vue.$http
        .get('admin/qualification_types')
        .then(response => commit('setAll', response.data), error => commit('stopLoading'))
    },
    fetch({ commit }, id) {
      this.$authorize('read', 'QualificationType')

      return Vue.$http.get(`admin/qualification_types/${id}`).then(response => commit('set', response.data))
    },
    create({ commit }, qualificationType) {
      this.$authorize('create', 'QualificationType')

      return Vue.$http.post('admin/qualification_types', { qualificationType }).then(
        response => {
          commit('set', response.data)
          commit('snackbar', { text: 'Qualification type created', type: 'success' }, { root: true })
          Vue.$router.push(`/qualification_types/${response.data.id}`)
        },
        error => {
          commit('snackbar', { text: 'Qualification type could not be created', type: 'error' }, { root: true })
          return Object.assign(qualificationType, error.response.data)
        }
      )
    },
    update({ commit }, qualificationType) {
      this.$authorize('edit', 'QualificationType')

      return Vue.$http.patch(`admin/qualification_types/${qualificationType.id}`, { qualificationType }).then(
        response => {
          commit('snackbar', { text: 'Qualification type updated', type: 'success' }, { root: true })
          commit('set', response.data)
        },
        error => {
          commit('snackbar', { text: 'Qualification type could not be updated', type: 'error' }, { root: true })
          return Object.assign(qualificationType, error.response.data)
        }
      )
    },
    destroy({ commit }, id) {
      this.$authorize('delete', 'QualificationType')

      return Vue.$http.delete(`admin/qualification_types/${id}`).then(response => commit('remove', id))
    }
  }
}
